<template>
    <div class="d-flex align-items-center justify-content-center text-center">
        <div>
            <h1 class="mb-5">
                You have been successfully logged out
            </h1>
            <p>
                <router-link
                    :to="{ name: 'login' }"
                    class="btn btn--secondary"
                >
                    Login
                </router-link>
            </p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            email: '',
            password: ''
        };
    },
    computed: {
        ...mapGetters('user', [
            'authenticated'
        ])
    },
    mounted() {
        this.logout(false);
    },
    methods: {
        ...mapActions('user', [
            'logout'
        ])
    }
};
</script>

<style lang="scss">
.page-logout {
    .content {
        max-width: 100%;
    }
}
</style>
